(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  const toast = (msg) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(window.__bayameToast);
    window.__bayameToast = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };

  // Header interactions
  const searchToggle = $('[data-search-toggle]');
  const searchBar = $('[data-header-search]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', () => {
      const open = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) $('input', searchBar)?.focus();
    });
  }

  const menuToggle = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Cart drawer
  const drawer = $('#BayameCartDrawer');
  const cartBody = $('[data-cart-body]');
  const openCart = () => {
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    renderCart();
  };
  const closeCart = () => {
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
  };
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency:window.Shopify?.currency?.active || 'INR'}).format((cents||0)/100); }
    catch(e){ return '₹' + ((cents||0)/100).toFixed(2); }
  };

  const updateCount = count => {
    $$('[data-cart-count]').forEach(el => { el.textContent = count; el.hidden = count < 1; });
  };

  const renderCart = async () => {
    if (!cartBody) return;
    cartBody.innerHTML = '<p class="rte">Loading your cart…</p>';
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      updateCount(cart.item_count);
      if (!cart.items.length) {
        cartBody.innerHTML = '<div class="empty-state"><h2>Your cart is empty</h2><p class="rte">Discover something beautiful for your everyday.</p><a class="btn btn--primary" href="/collections/all">Continue shopping</a></div>';
        return;
      }
      cartBody.innerHTML = `
        <div>${cart.items.map(item => `
          <div class="drawer-line">
            <a href="${item.url}"><img src="${item.image || ''}" alt=""></a>
            <div><div class="drawer-line__title"><a href="${item.url}">${item.product_title}</a></div>
            <div class="drawer-line__meta">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}<br>Qty ${item.quantity}</div></div>
            <strong>${money(item.final_line_price)}</strong>
          </div>`).join('')}</div>
        <div class="drawer-footer">
          <div class="drawer-footer__total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
          <a class="btn btn--primary btn--full" href="/checkout">Checkout</a>
          <a class="btn btn--ghost btn--full" href="/cart" style="margin-top:8px">View cart</a>
        </div>`;
    } catch(e) {
      cartBody.innerHTML = '<p class="rte">We could not load the cart. Please open the cart page.</p>';
    }
  };

  // Quick add / add to cart
  const addToCart = async (form) => {
    const btn = $('button[type="submit"]', form);
    if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding…'; }
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:fd});
      if (!res.ok) throw new Error('Add failed');
      const item = await res.json();
      const cart = await fetch('/cart.js').then(r => r.json());
      updateCount(cart.item_count);
      toast(`${item.product_title || 'Item'} added to cart`);
      if (drawer) openCart();
    } catch(e) {
      form.submit();
      return;
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || 'Add to cart'; }
    }
  };

  $$('form[data-quick-add], form[data-product-form]').forEach(form => {
    form.addEventListener('submit', e => {
      if (window.fetch && !form.dataset.buyNow) {
        e.preventDefault();
        addToCart(form);
      }
    });
  });

  // Product gallery
  const mainImage = $('[data-main-product-image]');
  $$('[data-product-thumb]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!mainImage) return;
      const src = btn.dataset.src;
      const alt = btn.dataset.alt || '';
      mainImage.src = src;
      mainImage.alt = alt;
      $$('[data-product-thumb]').forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // Collection filter mobile
  const filterToggle = $('[data-filter-toggle]');
  const filters = $('[data-filters]');
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', () => {
      const open = filters.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();